import { render, staticRenderFns } from "./NavItemBranch.vue?vue&type=template&id=1ec1c024&scoped=true&name=nav-item-branch&"
import script from "./NavItemBranch.vue?vue&type=script&lang=js&"
export * from "./NavItemBranch.vue?vue&type=script&lang=js&"
import style0 from "./NavItemBranch.vue?vue&type=style&index=0&id=1ec1c024&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec1c024",
  null
  
)

export default component.exports